
import $ from 'jquery';
import sequenceService from 'SequenceService';
import { View } from 'backbone';
import tableService from 'TableService';
import _template from 'properties/main/table-columns.ejs';
import GridColumnModel    from 'GridColumnModel';
import util from 'util/Util';
import dateUtil from 'shared/DateUtil';
import eventBus from 'EventBus.js';
import Moment from 'moment';
import undoService from 'UndoService.js';
import textConstants        from 'TextConstants';
import listService from 'ListService';
import focusController  from 'FocusController';
import constants        from 'Constants.js';

class MainTableColumnsView extends View {

  initialize(opts) {
    this.options = opts || {};
    this.template = _template;
    this.tagName = 'div';
    this.id = opts.el;
    this.gridElement = '#gridColumns';

    // Populate Model properties for Grid
    this.model.set('tableHeight', 100, {silent: true});
    this.model.set('tableWidth', 320, {silent: true});
    this.model.set('columns', ['Header', 'Type', 'State'], {silent: true});

    const self = this;
    this.model.set('colModel', [{name: 'header', index: 'header'},
      {
        name: 'type', index: 'type', width: 110,
        editable: true,
        cellEdit: true,
        edittype: 'select',
        formatter: 'select',
        editoptions: {
          value: this.getColumnTypeOptions(),
          dataEvents: [
            {
              type: 'change',
              fn: function (e, param, param2) {
                console.log(self.model)
                // Initializing everything on every value change.
                let gridData = self.model.get('gridData');
                let rowId = self.model.get('rowid');
                gridData[rowId] = new GridColumnModel({
                  'id': gridData[rowId].attributes['id'],
                  'header': gridData[rowId].attributes['header'],
                  'type': gridData[rowId].attributes['type'],
                  'state': gridData[rowId].attributes['state'],
                  'name': gridData[rowId].attributes['name'],
                  'width': gridData[rowId].attributes['width'],
                  'factoryKey': gridData[rowId].attributes['factoryKey'],
                  'displayType': gridData[rowId].attributes['displayType']
                });
              }
            }
          ]
        }
      },
      {name: 'stateDisplay', index: 'stateDisplay', width: 110}], {silent: true});

    this.events = {
      "click .itemNew": "itemNew",
      "click .itemRemove": "itemRemove",
      "click .itemSpaceEvenly": "itemSpaceEvenly",
      "click .itemUp": "itemUp",
      "click .itemDown": "itemDown",
      "change #itemColumnType" : 'updateItemColumnType'
    };

    this.listenTo(eventBus, "resizePropertiesPanel", this.render); 
    
    return this;
  }

  updateItemColumnType(){
    this.model.set('lastItemColumnTypeSelected', $('#itemColumnType').val(), { silent: true });
  }

  getColumnTypeOptions() {

    return {
      'tbl_button': 'Button',
      'tbl_tickbox': 'Checkbox',
      'tbl_childFormButton': 'Child App Button',
      'tbl_dateInput': 'Date Input',
      'tbl_dropDown': 'Drop-Down',
      'tbl_fileAttachment': 'File Attachment',
      'tbl_numericInput': 'Numeric Input',
      'tbl_radioButton': 'Radio Button',
      'tbl_textArea': 'Text Area',
      'tbl_textInput': 'Text Input',
      'tbl_timeInput': 'Time Input'
    };
  }

  // PF-2756 -- Use current column type selection during create
  itemNew() {
    const gridDataLength = this.model.get('gridData').length;
    const newIndex = gridDataLength + 1;

    const columnType = $('#itemColumnType').val();
    const selectedOption = $('#itemColumnType').find('option[value="' + columnType + '"]');
    const colFactoryKey = selectedOption[0].attributes['data-factorykey'].value;
    const colDisplayType = selectedOption[0].attributes['data-display-name'].value;

    // create new row
    const newColumnName = 'Column ' + newIndex;
    const newRow = new GridColumnModel({
      'id': sequenceService.nextDomId(),
      'header': newColumnName,
      'type': columnType,
      'stateDisplay': '',
      'name': colDisplayType + ' ' + newColumnName,
      'width': constants.DEFAULT_COLUMN_WIDTH,
      'factoryKey': colFactoryKey,
      'displayType': colDisplayType,
      'index': gridDataLength
    });

    // PF-2756 supply missing per-col-type attribute defaults
    this._applyTableColAttributes(newRow.attributes, columnType);

    // add new row to DataSource
    this.model.get('gridData').push(newRow);

    // Add new row to Grid
    $(this.gridElement).addRowData((newIndex), newRow.attributes);

    if (parseInt(this.model.get('selectedRowId')) > (this.model.get('gridData').length - 1)) {
      this.model.set('selectedRowId', this.model.get('gridData').length - 1, { silent: true });
    }
    this.model.trigger('change');

    tableService.buildSelectList(this.model);
    tableService.showColumnProperties(newIndex - 1, this.model);
  
    undoService.add({
      undo: () => {
        this.model.set('rowid', newIndex - 1, { silent: true });
        //Return the focus to the table in case the focus is in the column
        focusController.switchPropsViews();
        this.itemRemove();        
      },
      redo: () => {
        //Return the focus to the table in case the focus is in another object
        listService.currentId = this.model.get("id");
        focusController.switchPropsViews();
        this.itemNew();
      }
    }, textConstants.UNDO_MOVE);
  }

  itemRemove() {
    var gridData = this.model.get('gridData');
    var rowid = this.model.get('rowid');

    if (typeof rowid === 'undefined') {
      let maxRowId = $(this.gridElement).jqGrid('getGridParam', 'records');
      if (maxRowId > 0) { //Avoid negative numbers
        rowid = maxRowId - 1;
      }
    }

    $(this.gridElement).jqGrid('delRowData', rowid);
    gridData.splice(rowid, 1);
    this.model.set('gridData', gridData, {silent: true});

    tableService.buildSelectList(this.model);
    if(gridData.length > 0){
      if(parseInt(this.model.get('selectedRowId')) > (gridData.length - 1) ){
        this.model.set('selectedRowId', gridData.length - 1, {silent:true});
      }
    } else {
      this.model.set('selectedRowId', null, {silent: true});
    }
    this.model.trigger('change');

    undoService.add({
      undo: () => {
        //Return the focus to the table in case the focus is in another object
        listService.currentId = this.model.get("id");
        focusController.switchPropsViews();
        this.itemNew();             
      },
      redo: () => {
        this.model.set('rowid', rowid, { silent: true });
        //Return the focus to the table in case the focus is in the column
        focusController.switchPropsViews();
        this.itemRemove();          
      }
    }, textConstants.UNDO_MOVE);
  }

  itemSpaceEvenly() {
    this.model.set('gridColumnsEven', true);
  }

  itemUp() {
    var gridData = this.model.get('gridData');
    var rowid = Number(this.model.get('rowid'));

    if (rowid > 0) {
      gridData[rowid] = gridData.splice((rowid - 1), 1, gridData[rowid])[0];
      this.model.set('rowid', rowid - 1, {silent: true});
      this.model.set('gridData', gridData, {silent: true});
      this.model.trigger('change');
      this.render();

      undoService.add({
        undo: () => {        
          this.itemDown();     
        },
        redo: () => {
          this.itemUp();  
        }
      }, textConstants.UNDO_MOVE);

    }
  }

  itemDown() {
    var gridData = this.model.get('gridData');
    var rowid = Number(this.model.get('rowid'));

    if (rowid < ( gridData.length - 1)) {
      gridData[rowid] = gridData.splice((rowid + 1), 1, gridData[rowid])[0];
      this.model.set('rowid', rowid + 1, {silent: true});
      this.model.set('gridData', gridData, {silent: true});
      this.model.trigger('change');
      this.render();

      undoService.add({
        undo: () => {        
          this.itemUp();     
        },
        redo: () => {
          this.itemDown();  
        }
      }, textConstants.UNDO_MOVE);
      
    }
  }
    // Maintainers: per-column-type properties here.
    // You may need to adjust the exclude filter in SaveHelperService
    _applyTableColAttributes(attributes, kind) {
        let defaultFont = listService.accountSettings.DefaultFontSelected || 'verdana';

        const map = {
            'tbl_tickbox': a => {
                a.selected = 'false';
                a.transparentBackground = false;
            },

            'tbl_dateInput': a => {
                a.format = "MM/DD/YYYY";
                a.specific = '';
                a.showEmpty = 'true';
                a.showNow = 'false';
                a.maxYear = "2100";
                a.minYear = "1900";
                a.specfic = 'false';
                a.now = dateUtil.getFormattedDate( new Date(), a.format );
            },

            'tbl_timeInput': a => {
                a.format = "HH:MM:SS";
                a.specific = '1970-01-01 12:00:00';
                a.showEmpty = 'true';
                a.showNow = 'false';
                a.is24HourClock = 'true';
                a.hasSeconds = 'true';
                a.now = util.getTime( new Date(), {use24Hour: true, useSeconds: true});
                // PF-4915 Following style keys necessary for print. Override values later, if necessary.
                a.font = defaultFont + ',10';
                a.border = '1,solid';
                a.borderStyle = 'solid';
                a.borderSize = '1';
                a.cornerRadius = '0';
            },

            'tbl_numericInput': a => {
                a.align = 'right';
                a.text = '0.00';
                a.showLeadingZero = 'true';
                a.min = constants.NUMERIC_INPUT_MIN_VALUE.toString();
                a.allowNegative = 'false';
                a.max = constants.NUMERIC_INPUT_MAX_VALUE.toString();
                a.footerfun='';
                a.thousandsSeparator = ',';
            },

            'tbl_childFormButton': a => {
                a.mouseOverTextColor = '#000000';
                a.backgroundDownColor = '#FFFFFF';
                a.textColor = '#000000';
                a.formId = "";
                a.formName = "";
                a.text = 'App';
                a.border = '1, solid';
                a.bgGradientColor = '#FFFFFF';
                a.backgroundColor = '#FFFFFF';
                a.borderColor = '#CCCCCC';
                a.textDownColor = '#000000';
                a.bgGradientOverColor = '#FFFFFF';
                a.formGUID = "";
                a.cornerRadius = '0';
                a.bgGradientDownColor = '#FFFFFF';
                a.newWindow = 'true';
                a.linkId = "";
                a.childInstanceGUID = "";
                a.mouseOverColor = '#FFFFFF';
                a.showError = 'true';
            },

            'tbl_textArea': a => {
            },

            'tbl_button': a => {
              a.text = 'Button'
            },

            'tbl_textInput': a => {
            },

            'tbl_dropDown': a => {
                // Dropdown options
                a.Property = [
                    {_id: 'captions', Item: [{_value: 'Item 1'}, {_value: 'Item 2'}, {_value: 'Item 3'}]},
                    {_id: 'values', Item: [{_value: '1'}, {_value: '2'}, {_value: '3'}]}
                ];

            },

            'tbl_fileAttachment': a => {
                a.customFiltypes = '';
                a.buttonPositionLeft = 'true';
                a.buttonTextColor = '#000000';
                a.buttonBackgroundColor = "#FFFFFF";
                a.buttonFont = defaultFont + ", 10";
                a.buttonLabelDetach = "Detach";
                a.maxSize = "2097152";
                a.buttonLabelAttach = "Attach";
                a.filetypes = "0";
            },

            'tbl_radioButton': a => {
              a.transparentBackground = false;
            }

        };

        if (map[kind]) {
            map[kind]( attributes );
        }
    }

  saveCell(rowid, cellname, value) {
    const gridData = this.model.get('gridData');

    // PF-5601 If column type has changed delete previous behaviors
    if (value != gridData[rowid].attributes.type) {
      // Get behaviors
      const id = gridData[rowid].attributes.id;
      const targetBehaviors = listService.getBehaviorInstanceByObject(id);
      const behaviorList = listService.getBehaviorsByObjectId(id);
        // If has any - remove it
        if (behaviorList.length > 0) {
            this.removeBehaviors(targetBehaviors);
        }
    }

    gridData[rowid].attributes[cellname] = value;
    // Set factoryKey
    let opt = $('#itemColumnType').find('option[value="' + value + '"]');
    let key = opt[0].attributes['data-factorykey'].value;
    let newRow = new GridColumnModel({
      'id': gridData[rowid].attributes['id'],
      'header': gridData[rowid].attributes['header'],
      'type': value,
      'stateDisplay': '',
      'name': gridData[rowid].attributes['name'],
      'width': constants.DEFAULT_COLUMN_WIDTH,
      'factoryKey': value,
      'displayType': key
    });


    //  supply missing per-col-type attribute defaults
    this._applyTableColAttributes(newRow.attributes, value);

    gridData[rowid].attributes = newRow.attributes;
    gridData[rowid].attributes.factoryKey = key;

    this.model.set('gridData', gridData, {silent: true});
    this.model.trigger('change');
    this.render();
    util.setGridScrollPos(this.model);
  }

  removeBehaviors(behaviorInstances) {
    behaviorInstances.map( (instance, id) => {
        listService.destroyBehaviorInstance(id);
    });
}

  // Method that renders an scroll in the grid in order to navigate the same on small screens.
  resizeGrid(gridEl) {
    let grid = $(gridEl + ' .ui-jqgrid-btable');
    if (grid) {
      grid.each(function (index) {
        let gridId = $(this).attr('id');
        let gridParentWidth = $('#gbox_' + gridId).parent().width();
        $('#' + gridId).setGridWidth(gridParentWidth);
      });
    }
  }

  checkForMissingColumnStateAndInitialize(column) {
    // Initializing Default State Settings if the column doesn't have anyone.
    if (column && !column.attributes.state) {
      column.attributes.state = new Map();
      column.attributes.stateDisplay = 'default';
    }
  }

  render() { 
    this.$el.empty();
    if (this.template) {
      this.$el.html(this.template(this.model.toJSON()));
    } 

    let settingsContainer = $("#settings");
    let gridWidth = this.model.get('tableWidth');

    if (settingsContainer) {
      gridWidth = settingsContainer.width()
    } 

    const self = this;
    $(this.gridElement).jqGrid({
      datatype: "local",
      shrinkToFit: true,
      cellEdit: true,
      autoencode: true,
      scrollOffset:0,
      height: this.model.get('tableHeight'),
      width: gridWidth,
      altRows: true,
      gridComplete: function () {
        $(self.gridElement + " tr.jqgrow:odd").css("background", "#DDDDDC");
      },

      colNames: this.model.get('columns'),
      colModel: this.model.get('colModel'),
      beforeSelectRow: function (rowId, e) { 
        self.model.set('rowid', rowId);
          $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
      },
      ondblClickRow: function (rowid, iRow, iCol, e) { 
        tableService.showColumnProperties(rowid, self.model);
      },
      afterSaveCell: function (rowid, cellname, value) {
        self.saveCell(rowid, cellname, value);
      },
      afterEditCell(rowId, cellName, value, iRow, iCol) { 
        $("#" + iRow + "_" + cellName).bind('blur', function () { 
          $(self.gridElement).saveCell(iRow, iCol);
        });
      } 
    });
 
    let gridData = this.model.get('gridData');
    let pos = 0;
    gridData.forEach(d => {
      if (d) {
        this.checkForMissingColumnStateAndInitialize(d);
        $(this.gridElement).jqGrid('addRowData', pos, d.attributes);
      }

      pos++;
    });

    tableService.buildSelectList(this.model);
    this.resizeGrid(this.gridElement);
    this.delegateEvents();

    const itemColumnType = this.model.get('lastItemColumnTypeSelected');
    if ( itemColumnType ){
      $('#itemColumnType').val(itemColumnType);
    }
      $(this.gridElement).jqGrid('setSelection', 0);

    return this;
  }
}

export default MainTableColumnsView;
